import React from 'react'
import clsx from 'clsx'
import { priorityBadgeColor } from '../allocationUtils'

export default function TaskPoolPanel({
  tasks = [],
  taskPool = [],
  isLoading = false,
  onDragStart,
  onDragEnd,
}) {
  const items = taskPool.length > 0 ? taskPool : tasks

  return (
    <div className="col-span-12 lg:col-span-3 flex flex-col h-full">
      <div className="bg-surface-container-lowest rounded-[22px] p-6 border border-outline-variant/20 flex flex-col shadow-sm h-full">
        {/* Header */}
        <div className="flex flex-col mb-4">
          <div className="flex items-center justify-between">
            <h3 className="font-headline font-bold text-on-surface text-base">Task Pool</h3>
            <span className="bg-surface-container-high text-[10px] font-bold px-2.5 py-1 rounded-lg text-outline uppercase tracking-tight">
              {items.length} BACKLOG
            </span>
          </div>
          <p className="text-[11px] text-outline mt-0.5">Unassigned Tasks &bull; Based on Tasks</p>
        </div>

        {isLoading && (
          <div className="text-sm text-on-surface-variant py-4 text-center">Loading tasks...</div>
        )}

        <div className="space-y-4 task-pool-scroll pr-1 custom-scrollbar flex-1">
          {items.map((task) => {
            const pc = String(task.priority || '').toUpperCase()
            const borderCls =
              pc === 'HIGH' || pc === 'URGENT' || pc === 'CRITICAL'
                ? 'border-l-error'
                : pc === 'LOW'
                ? 'border-l-outline'
                : 'border-l-primary'

            return (
              <div
                key={task.task_id}
                draggable
                onDragStart={() => onDragStart && onDragStart(task)}
                onDragEnd={onDragEnd}
                className={clsx(
                  'p-4 rounded-xl bg-surface-container-low border-l-4 hover:shadow-md transition-all cursor-grab active:cursor-grabbing group',
                  borderCls,
                )}
              >
                <div className="flex justify-between items-start mb-2">
                  <span
                    className={clsx(
                      'font-label text-[10px] font-bold uppercase tracking-wider px-2 py-0.5 rounded-full',
                      priorityBadgeColor(task.priority),
                    )}
                  >
                    {task.priority || 'NORMAL'}
                  </span>
                  <span className="text-[10px] font-bold text-on-surface-variant">
                    {task.effort_estimate ? `${task.effort_estimate}h` : '—'}
                  </span>
                </div>
                <h4 className="font-bold text-sm text-on-surface group-hover:text-primary transition-colors leading-snug">
                  {task.task_name}
                </h4>
                <p className="text-[11px] text-on-surface-variant mt-1 truncate">
                  {task.project_name}
                </p>
                <div className="mt-3 flex items-center gap-2">
                  <span className="material-symbols-outlined text-xs text-outline select-none">
                    drag_indicator
                  </span>
                  <span className="text-[10px] text-outline">drag to employee row</span>
                </div>
              </div>
            )
          })}

          {!isLoading && items.length === 0 && (
            <div className="rounded-xl bg-surface-container-low p-4 text-center text-sm text-on-surface-variant">
              No unassigned tasks in pool.
            </div>
          )}
        </div>
      </div>
    </div>
  )
}
